export class ModelNavStack 
{

    private items = [];

    private curIndex = -1;

    private isLocked = false;

        canGoBack() {

            return this.curIndex > 0;
        }

        canGoForward(){
            return this.curIndex < this.items.length - 1;
        }
        
        back () {
                this.curIndex--;
                return this.items[this.curIndex];
        }

        forward()
        {
                this.curIndex++;
                return this.items[this.curIndex];

        }

        add(value) {

            if (!this.isLocked) {
                if (this.items.length > 0 &&  this.curIndex < this.items.length - 1) {
                    this.items.length = this.curIndex + 1;
                    this.curIndex = this.items.length - 1;
                }

                this.items.push(value);
                this.curIndex++;
            }
        }

        endUpdate() {
            this.isLocked = false;
        }

        beginUpdate () {
            this.isLocked = true;

        }
        
        backName() {
            if (this.canGoBack())
            return this.items[this.curIndex - 1];
            return "";
        }

        /**
         * Top of stack( current)
         * @returns {} 
         */
        topName() {
            if (this.items.length > 0)
                return this.items[this.items.length - 1];
            return "";

        }

        forwardName() {
            if (this.canGoForward())
                return this.items[this.curIndex + 1];
            return "";
        }
    }




// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.model-nav-stack.ts